<template>     
      <uploader :options="options" :file-status-text="statusText" @file-success="fileSuccess"  @file-added="onFileAdded" @file-progress="onFileProgress"
        @file-error="onFileError" class="uploader-example" ref="uploader" >
        <uploader-unsupport></uploader-unsupport>
        <uploader-drop>
        <uploader-list></uploader-list>
          <!--<i class="images" v-show='shipi' @click="Videoshow"></i>-->
          <!--<div class="delete" v-show="delshow" @click="delVideo"></div>-->
          <img src="../../../../../html/pages/mall/details/images/del.png" alt="" class="delete" @click="delVideo" v-if="goodsVideo">
          <iframe :src="goodsVideo" frameborder='0' allow='autoplay;encrypted-media'  style='width: 420px;height: 371px;' v-show='shipi'></iframe>  
          <uploader-btn v-show='!shipi'><img class="activeImg"  alt=""/></uploader-btn>
        </uploader-drop>   
           
      </uploader> 
       
</template>

<script>
import '../../../../../html/pages/mall/details/details.scss';
import '../../../../../html/pages/mall/details/details.css';
import '../../../../../html/pages/mall/details/detailBack.css';
import {Details } from '../../../../../api/index.js';
export default {
  name: 'detailVides',
    data () {
      return {
        options: {
          target: '/Api/Common/VueUploadVideo', // '//jsonplaceholder.typicode.com/posts/',
          testChunks: false
        },
        attrs: {
          accept: 'image/*'
        },
        statusText: {
          success: '成功了',
          error: '出错了',
          uploading: '上传中',
          paused: '暂停中',
          waiting: '等待中'
        },
        goodsVideo:'',
        shipi:false,
      }
    },
    methods: {
      delVideo(){
        this.goodsVideo=''
        this.shipi=false
      },
      fileSuccess (rootFile, file, message, chunk) {
        var str = chunk.processedState.res
        var str1 = str.split('"');
        this.goodsVideo=str1[3]
        this.shipi = true
      },
      Videoshow(){
        this.goodsVideo=''
        this.shipi=false
      },
      onFileAdded(){
        console.log('2')
        this.$message({
          showClose: true,
          message: '正在上传请稍后',
          type: 'warning'
        });
      },
      onFileProgress(){
        console.log('3')
        
      },
      onFileError(){
        console.log('4')
      },
      fileComplete () {
        console.log('5')
      },
      async Update(){
        var _this =this
        let res = await Details({
            id: this.DataId
        });
        if(res.Type == 'Success'){
            var data = res.Data.good
            this.goodsVideo = data.VideoPath
            console.log(this.goodsVideo)
             if(this.goodsVideo ==null){
              this.shipi = false
            }else{
              this.shipi = true
            }
        }
      }
    },
    created () {
      if(this.$route.query.id){
        this.DataId =this.$route.query.id
        this.Update()
      }
      // if(this.goodsVideo==''){
      //   this.shipi=false
      //   console.log('2222222222222222222222')
      // }
      this.$nextTick(() => {
        window.uploader = this.$refs.uploader.uploader
        
      })
    }
  }
</script>
<style>
.images{background: url("../../../../../html/pages/mall/details/images/close.png") no-repeat center center;display: inline-block;width: 23px;height: 21px;position: relative;top: 32px;left: 393px;}
.uploader-list{display:none}
</style>